<template>
  <div>
    <SkeletonLoader
      v-if="loading"
      style="margin-bottom: 16px;"
      :types="['loader', 'div wp100 h150']"
    />
    <div
      v-if="schoolGidsen.length"
      class="content-block"
    >

      <h3 class="content-block-title">
        Schoolgids en schoolplan
      </h3>
      <div>
        <a
          class="gids"
          target="_blank"
          :href="mostRecentGids | schoolgidsUrl"
        >
          schoolgids
          {{ mostRecentGids.jaar }}
        </a>
      </div>
      <div v-if="mostRecentPlan">
        <a
          class="gids"
          target="_blank"
          :href="mostRecentPlan | schoolgidsUrl"
        >
          schoolplan {{ mostRecentPlan.jaar }}
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import SkeletonLoader from '../../components/SkeletonLoader.vue';
import scholenRepository from '../../repositories/scholenRepository';

export default {
  components: {
    SkeletonLoader,
  },
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      schoolGidsen: [],
    };
  },
  computed: {
    mostRecentGids() {
      if (!this.schoolGidsen.length) {
        return null;
      }
      return this.schoolGidsen[0];
    },

    mostRecentPlan() {
      if (!this.schoolplannen.length) {
        return null;
      }
      return this.schoolplannen[0];
    },
  },
  created() {
    this.loadSchoolgidsen();
  },
  methods: {
    loadSchoolgidsen() {
      this.loading = true;
      Promise.all([
        scholenRepository.listSchoolGidsen({
          'where[school_id]': this.school.id,
        }),
        scholenRepository.listSchoolPlannen({
          'where[school_id]': this.school.id,
        }),
      ]).then(([sgResponse, spResponse]) => {
        this.schoolGidsen = sgResponse.data
          .sort((a, b) => (a.jaar > b.jaar ? -1 : 1));
        this.schoolplannen = spResponse.data
          .sort((a, b) => (a.jaar > b.jaar ? -1 : 1));
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.gids {
  display: block;
  margin-bottom: 4px;
  &:hover {
    color: red;
  }
}
</style>
